import { render, staticRenderFns } from "./popularExams.vue?vue&type=template&id=4d1917ab&"
import script from "./popularExams.vue?vue&type=script&lang=js&"
export * from "./popularExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports